@if (displayAsCheckbox())
{
  <mat-checkbox
    [disabled]="disabled()"
    [checked]="locked()"
    [ngClass]="{'orange-label': locked()}"
    (click)="openDialog()">
    @if (locked())
    {
      Integration Locked ({{lockReason()}})
    }
    @else
    {
      Integration Unlocked
    }
  </mat-checkbox>
}
@else
{
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="openDialog()">
    @if (locked()) {
      <span>Unlock</span>
    } @else {
      <span>Lock</span>
    } Selected Integrations
  </button>
}


